import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, FileText } from "lucide-react";
import { SITE } from "@/data/site";

/* Barre fixe mobile — apparaît après 400px de scroll */
export const StickyBar = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`sticky-bar fixed bottom-0 inset-x-0 z-40 bg-white p-3 flex gap-2 md:hidden transition-transform duration-300 ${visible ? "translate-y-0" : "translate-y-full"}`}
      data-testid="mobile-sticky-bar"
    >
      <a href={SITE.phoneHref} className="btn-base btn-metal flex-1 !py-3 !text-sm font-bold" data-testid="sticky-call-btn">
        <Phone size={16} aria-hidden="true" />
        Appeler
      </a>
      <Link to="/devis" className="btn-base btn-outline-deep flex-1 !py-3 !text-sm font-bold" data-testid="sticky-devis-btn">
        <FileText size={16} aria-hidden="true" />
        Devis 48h
      </Link>
    </div>
  );
};
